export default "/_next/static/fonts/SmileScript-40-eef006ad29a8d127e21e35579d3df10f.woff2";